import { useFeatureNavigation } from '@/hooks/useFeatureNavigation';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type FunctionComponent } from 'react';
import { Button } from './ui/button';

interface FeatureNavigatorProps {
  className?: string;
}

export const FeatureNavigator: FunctionComponent<FeatureNavigatorProps> = ({ className }) => {
  const { canNavigatePrev, canNavigateNext, currentIndex, totalCount, navigatePrev, navigateNext, hasNavigation } =
    useFeatureNavigation();

  // Don't render if there's no navigation context or only one feature
  if (!hasNavigation) {
    return null;
  }

  return (
    <div className={`flex items-center justify-between gap-2 ${className || ''}`}>
      <Button
        variant='outline'
        size='icon'
        onClick={navigatePrev}
        disabled={!canNavigatePrev}
        aria-label='Previous feature'>
        <ChevronLeft />
      </Button>

      <span className='text-sm text-muted-foreground whitespace-nowrap'>
        Feature {currentIndex + 1} of {totalCount}
      </span>

      <Button
        variant='outline'
        size='icon'
        onClick={navigateNext}
        disabled={!canNavigateNext}
        aria-label='Next feature'>
        <ChevronRight />
      </Button>
    </div>
  );
};
